import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { MDBAlert, MDBBtn, MDBIcon, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { deleteHuntGroup, deleteOrganization, deletePool, deleteUser } from "../../../apiclients/streamsapi_bridge.js";
import { useNavigate } from "react-router";

export default function DeleteOrgORPool(props){
  const [internalError , setInternalError] = useState(false);
  const { t } = useTranslation();
  const [isloading, setIsloading] = useState(false);
  const [pools , setpools] = useState()
 
  const navigate = useNavigate();

    async function removeOrg(e) {
        try {
            setInternalError(false);
            setIsloading(true);
            let apiResponse;
            let tab = "tab1";
            if (props.delType == 1) {
                apiResponse = await deleteOrganization(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.id);
                tab = "tab1";
            } else if (props.delType == 2) {
                apiResponse = await deletePool(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.id);
                tab = "tab2";
            }
            setTimeout(() => { setIsloading(false) }, 1000);
            if (apiResponse.status == 200) {
                let apiData = await apiResponse.json();
                localStorage.setItem("s_message", apiData.message);
                navigate(".", {
                    state: {
                        tab1: tab
                    }
                });
                window.location.href = "/orggroupslandingpage";
                props.onClose();
            } else {
                setInternalError(true);
            }
        } catch (e) {
            setInternalError(true);
        }
    }
    useEffect(() => {
        console.log("org props data " + JSON.stringify(props?.orgData))
        if (props?.delType == 1) {
            setpools(props?.orgData?.org_pools?.map(e => e.pool_name).join(","));
        }
    }, [props?.orgData])
    
  return (
    <> 
          {props?.delType === 1 && (
              <div>
                  <p>
                      You have selected the following Org(s) to remove:{" "} <br />
                      <strong>{props?.orgData?.org_name}</strong>
                  </p>
                  <div>
                      {pools ? (
                          <p>
                              The selected Organizations contain <strong>{pools}</strong> pool(s)
                              and will be moved to Default Org.
                          </p>
                      ) : (
                          <p>The selected Organizations do not contain any pools.</p>
                      )}
                  </div>
              </div>
          )}

          {props?.delType === 2 && (
              <div>
                  <p>
                      You have selected the following Pool(s) to remove:{" "}
                      <strong>{props?.orgData?.pool_name}</strong>
                  </p>
                  <p>DID(s) under these Pool(s) will be moved to Default Pool.</p>
              </div>
          )}
          <MDBModalFooter>
              <MDBBtn color="secondary" onClick={props.onClose}>
                  {t("cancel")}
              </MDBBtn>
              <MDBBtn onClick={(e) => removeOrg(e)}>{t("remove")}</MDBBtn>
          </MDBModalFooter>
          {isloading && (
              <>
                  <div className="loadingclass">
                      <MDBBtn disabled>
                          <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                          Loading...
                      </MDBBtn>
                  </div>
              </>
          )}
          {internalError && (<MDBAlert
              open
              className="alert-center"
              color="danger"
              autohide
              position="top-center"
              delay={5000}
          >Internal Server Error</MDBAlert>)}
      </>
  );
}
